// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.news__link[data-v-7b6966f8] {\n  font-weight: bold;\n  text-decoration: underline;\n}\n", ""]);
// Exports
module.exports = exports;
